import React, { Component } from "react";
import { Field, FieldArray } from "redux-form";
import { Flex, Box } from "rebass";

import RaisedButton from "material-ui/RaisedButton";
import IconButton from "material-ui/IconButton";
import { Card, CardHeader, CardText } from "material-ui/Card";
import { cyan500 } from "material-ui/styles/colors";
import { TextField } from "redux-form-material-ui";
import { IconAdd, IconRemove } from "../components/mui/icon";
import { DivErrorMessage } from "./styled";
import { checkNumber } from "../components/form/ValuesForm";

const required = value => (value ? undefined : "Required");
const number = value =>
  value && isNaN(Number(value)) ? "Must be a number" : undefined;

class AdvancePrice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: true
    };
  }
  handleExpandChange = expanded => {
    this.setState({ expanded: expanded });
  };

  handleAdd = fields => {
    fields.push({});
  };
  renderPriceFields = (items, index, fields) => (
    <Flex w={[1]} key={index}>
      <Box w={[1]} pr={[1]}>
        <Field
          key={index}
          label=""
          name={`${items}.qty`}
          component={TextField}
          placeholder="Qty"
          type="number"
          style={{ width: 70 }}
          inputStyle={{ width: 70 }}
          validate={[required, number]}
          parse={v => checkNumber(v)}
        />
      </Box>
      <Box w={[1]} pr={[1]}>
        <Field
          key={index}
          label=""
          name={`${items}.discount`}
          component={TextField}
          type="number"
          validate={[required, number]}
          placeholder="Discount"
          parse={v => checkNumber(v)}
        />
      </Box>
      <Box>
        <IconButton
          iconStyle={{ color: cyan500 }}
          onClick={() => fields.remove(index)}
        >
          <IconRemove />
        </IconButton>
      </Box>
    </Flex>
  );
  renderMarginFields = (items, index, fields) => (
    <Flex w={[1]} key={index}>
      <Box w={[1]} pr={[1]}>
        <Field
          key={index}
          label=""
          name={`${items}.qty`}
          component={TextField}
          placeholder="Qty"
          type="number"
          style={{ width: 70 }}
          inputStyle={{ width: 70 }}
          validate={[required, number]}
          parse={v => checkNumber(v)}
        />
      </Box>
      <Box w={[1]} pr={[1]}>
        <Field
          key={index}
          label=""
          name={`${items}.margin`}
          component={TextField}
          type="number"
          validate={[required, number]}
          placeholder="Margin"
          parse={v => checkNumber(v)}
        />
      </Box>
      <Box>
        <IconButton
          iconStyle={{ color: cyan500 }}
          onClick={() => fields.remove(index)}
        >
          <IconRemove />
        </IconButton>
      </Box>
    </Flex>
  );
  renderPricesList = ({ fields, meta: { error, submitFailed } }) => {
    if (fields.length <= 0) {
      return (
        <Flex p={[1]} direction={"column"} justify={"flex-start"}>
          <RaisedButton
            style={{ width: 135 }}
            primary
            label="Tier price"
            labelPosition={"before"}
            onClick={() => this.handleAdd(fields)}
            icon={<IconAdd />}
          />
          <Box pt={[1]}>click + to add new price tier</Box>
        </Flex>
      );
    }
    return (
      <Flex p={[1]} direction={"column"}>
        <RaisedButton
          primary
          style={{ width: 135 }}
          label="Tier Price"
          labelPosition={"before"}
          onClick={() => this.handleAdd(fields)}
          icon={<IconAdd />}
        />
        <Flex w={[1]} pt={[1]}>
          <Box w={["100px"]}>Qty</Box>
          <Box w={[1]}>Discount</Box>
          <Box />
        </Flex>
        <Box w={[1]}>{fields.map(this.renderPriceFields)}</Box>
        {submitFailed && error && <DivErrorMessage> {error} </DivErrorMessage>}
      </Flex>
    );
  };
  renderMarginList = ({ fields, meta: { error, submitFailed } }) => {
    if (fields.length <= 0) {
      return (
        <Flex p={[1]} direction={"column"} justify={"flex-start"}>
          <RaisedButton
            style={{ width: 150 }}
            primary
            label="Tier Margin"
            labelPosition={"before"}
            onClick={() => this.handleAdd(fields)}
            icon={<IconAdd />}
          />
          <Box pt={[1]}>click + to add new margin tier</Box>
        </Flex>
      );
    }
    return (
      <Flex p={[1]} direction={"column"}>
        <RaisedButton
          primary
          style={{ width: 150 }}
          label="Tier Margin"
          labelPosition={"before"}
          onClick={() => this.handleAdd(fields)}
          icon={<IconAdd />}
        />
        <Flex w={[1]} pt={[1]}>
          <Box w={["100px"]}>Qty</Box>
          <Box w={[1]}>Margin</Box>
          <Box />
        </Flex>
        <Box w={[1]}>{fields.map(this.renderMarginFields)}</Box>
        {submitFailed && error && <DivErrorMessage> {error} </DivErrorMessage>}
      </Flex>
    );
  };
  render() {
    return (
      <Card
        style={{ marginTop: 16 }}
        expanded={this.state.expanded}
        onExpandChange={this.handleExpandChange}
      >
        <CardHeader
          title="Advanced"
          actAsExpander={true}
          showExpandableButton={true}
        />
        <CardText expandable={true}>
          <FieldArray
            name="advanced_price.prices"
            component={this.renderPricesList}
          />
          <FieldArray
            name="advanced_price.margins"
            component={this.renderMarginList}
          />
        </CardText>
      </Card>
    );
  }
}

export default AdvancePrice;



// WEBPACK FOOTER //
// ./src/products/AdvancePrice.js